import { render, staticRenderFns } from "./PolymerProduct.vue?vue&type=template&id=23c016d4&"
import script from "./PolymerProduct.vue?vue&type=script&lang=js&"
export * from "./PolymerProduct.vue?vue&type=script&lang=js&"
import style0 from "./PolymerProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports